import React, { FC } from "react";
import Text from "@src/lib/ui/Text";
import EmojiPicker from "../../../lib/ui/EmojiPicker";
import BackgroundGradientIcon from "../../../lib/ui/BackgroundGradientIcon";
import { LINEAR_GRADIENTS } from "./CoverImage";
import { CoverImageFragment } from "@src/fragments.generated";
import { Button } from "@src/lib/ui/Button";
import { BackgroundGradient } from "@src/types.generated";
import XIcon from "@src/lib/icons/18px/x";

type Props = {
  coverImage?: CoverImageFragment;
  selectedGradient: BackgroundGradient | null | undefined;
  setSelectedGradient: (gradient: BackgroundGradient) => void;
  emoji: string;
  setEmoji: (emoji: string) => void;
  clearEmoji: () => void;
  allowedGradients?: BackgroundGradient[];
};

const allBackgroundGradients = [
  BackgroundGradient.Gradient_1,
  BackgroundGradient.Gradient_2,
  BackgroundGradient.Gradient_3,
  BackgroundGradient.Gradient_4,
  BackgroundGradient.Gradient_5,
  BackgroundGradient.Gradient_6,
  BackgroundGradient.Gradient_7,
  BackgroundGradient.Gradient_8,
  BackgroundGradient.Gradient_9,
  BackgroundGradient.Gradient_10,
];

const CoverImagePickerEmojiTab: FC<Props> = ({
  coverImage,
  selectedGradient,
  setSelectedGradient,
  emoji,
  setEmoji,
  clearEmoji,
  allowedGradients,
}) => {
  const backgroundGradients = allowedGradients || allBackgroundGradients;
  return (
    <div className="flex size-full flex-col">
      <div className="mt-2 flex h-[60px] flex-col">
        <Text variant="fine-print-description">Background</Text>
        <div className="mt-2 flex">
          {backgroundGradients.map((gradient, index) => (
            <BackgroundGradientIcon
              key={index}
              gradientStyle={LINEAR_GRADIENTS[gradient]}
              selected={
                selectedGradient == gradient ||
                coverImage?.background == gradient
              }
              onClick={() => setSelectedGradient(gradient)}
            />
          ))}
        </div>
      </div>
      <div className="my-2 flex flex-col overflow-auto">
        <div className="flex h-8 w-full items-center justify-between">
          <Text
            className="z-[9999] -mb-2.5 w-full bg-white py-2.5"
            variant="fine-print-description"
          >
            Emoji
          </Text>
          {emoji !== "" && (
            <Button
              variant="ghost"
              onClick={() => clearEmoji()}
              className="z-[9999] mb-[-10px] bg-white pb-5"
            >
              <XIcon className="size-4" />
              clear
            </Button>
          )}
        </div>
        <div className="mt-1.5 max-h-[400px]">
          <EmojiPicker
            enableFrequentEmojiSort={false}
            onEmojiSelect={setEmoji}
            navPosition={"none"}
            previewPosition={"none"}
            skinTonePosition={"search"}
            showFrequentCategory={false}
          />
        </div>
      </div>
    </div>
  );
};

export default CoverImagePickerEmojiTab;
